import React from 'react';
import { VENUE_DATA, EVENT_DATA, AVATAR_URLS } from '../../constants/venueData';
import { formatRating, formatHostNames } from '../../utils/helpers';
import { ReactComponent as MedalFillIcon } from '../icons/medal-fill-icon.svg';
import { ReactComponent as MagicStarIcon } from '../icons/magic-star-icon.svg';
import { ReactComponent as ArrowRightIcon } from '../icons/arrow-right-icon.svg';
import { ReactComponent as CalendarGreyIcon } from '../icons/calendar-grey-icon.svg';
import { ReactComponent as BgVector } from '../icons/bg_subtle_logo.svg';
// import './VenueCard.css';

const VenueCard = () => {
  return (
    <>
    <div className='relative hidden lg:block 2xl:hidden'>
      <BgVector className='absolute -top-[150px] left-0' />
    </div>
    <div className="content-width mx-auto container-padding py-12">
      <div className="flex flex-col lg:flex-row gap-10 items-start">
        {/* Image Section */}
        <div className="md:h-[512px] relative lg:w-[400px] h-[200px] w-full flex-shrink-0 overflow-hidden">
          <img 
            src={VENUE_DATA.image}
            alt={`${VENUE_DATA.name} interior`} 
            className="absolute inset-0 max-w-none object-cover pointer-events-none w-full h-full"
          />
        </div>
        
        {/* Details Section */}
        <div className="flex flex-col gap-8 flex-grow w-full">
          {/* Venue Details */}
          <div className="flex flex-col gap-6 w-full">
            {/* Tag */}
            <div className="flex gap-2 items-center px-3 py-3 rounded-lg w-fit bg-accent-orange-10">
              <div className="w-5 h-5 flex-shrink-0">
                <MedalFillIcon />
              </div>
              <p className="font-semibold text-sm uppercase text-accent-orange">
                VENUE PICK OF THE WEEK
              </p>
            </div>
            
            {/* Name and Address */}
            <div className="flex items-start justify-between w-full">
              <div className="flex flex-col gap-2">
                <h2 className="font-medium text-gray-900 text-[32px] leading-normal">
                  {VENUE_DATA.name}
                </h2>
                <p className="font-medium text-gray-600 text-xl leading-relaxed">
                  {VENUE_DATA.address}
                </p>
              </div>
              <div className="bg-gray-50 border border-gray-300 text-primary flex gap-2.5 items-center justify-center p-3 rounded-lg flex-shrink-0">
                <ArrowRightIcon className="w-6 h-6 text-primary" />
              </div>
            </div>
            
            {/* Ratings */}
            <div className="flex gap-3 items-center">
              <div className="flex-shrink-0">
                <MagicStarIcon />
              </div>
              <p className="font-medium text-gray-600 text-xl leading-relaxed">
                {formatRating(VENUE_DATA.rating, VENUE_DATA.reviews)}
              </p>
            </div>
          </div>
          
          {/* Divider */}
          <div className="flex items-center justify-center w-full">
            <div className="w-full h-px bg-gray-300"></div>
          </div>
          
          {/* Event Details */}
          <div className="flex flex-col gap-4 w-full">
            <p className="font-semibold text-gray-600 text-base uppercase tracking-widest">
              RECENT EVENT
            </p>
            
            <div className="flex flex-col gap-8 w-full">
              {/* Event Title and Hosts */}
              <div className="flex flex-col gap-2 w-full">
                <p className="font-medium text-[32px] text-black leading-normal w-full">
                  {EVENT_DATA.title}
                </p>
                
                <div className="flex gap-2 items-center w-full">
                  <div className="flex gap-2 items-center w-[71px] relative">
                    {AVATAR_URLS.hosts.map((avatar, index) => (
                      <div key={index} className={`w-12 h-12 rounded-full overflow-hidden ${index === 1 ? 'absolute left-6' : ''}`}>
                        <img 
                          src={avatar} 
                          alt={EVENT_DATA.hosts[index]} 
                          className="w-full h-full object-cover"
                        />
                      </div>
                    ))}
                  </div>
                  <p className="font-normal text-gray-600 text-xl leading-relaxed flex-1">
                    Hosted by {formatHostNames(EVENT_DATA.hosts)}
                  </p>
                </div>
              </div>
              
              {/* Date and Time */}
              <div className="flex gap-3 items-center">
                <div className="flex-shrink-0">
                  <CalendarGreyIcon />
                </div>
                <p className="font-normal text-gray-600 text-xl leading-relaxed">
                  {EVENT_DATA.date} • {EVENT_DATA.time}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default VenueCard; 
